{
  "navigation": {
    "home": "Início",
    "booking": "Marcar",
    "contact": "Contacto",
    "login": "Entrar"
  },
  "buttons": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "submit": "Enviar",
    "close": "Fechar",
    "back": "Voltar",
    "next": "Seguinte",
    "copy": "Copiar",
    "retry": "Tentar novamente",
    "confirm": "Confirmar"
  },
  "errors": {
    "generic": "Algo correu mal. Tente novamente.",
    "network": "Erro de rede. Verifique a sua ligação.",
    "validation": "Por favor verifique os campos.",
    "unavailable": "Serviço temporariamente indisponível.",
    "configInvalid": "Configuração incompleta. Contacte o suporte."
  },
  "loading": "A carregar…",
  "fields": {
    "name": "Nome",
    "email": "E-mail",
    "phone": "Telefone",
    "message": "Mensagem",
    "subject": "Assunto",
    "birthDate": "Data de nascimento",
    "password": "Palavra-passe"
  },
  "preferences": {
    "title": "Preferências de comunicação",
    "subtitle": "Escolha o que quer receber em {email}.",
    "subtitleNamed": "Escolha o que quer receber da {clinic} em {email}.",
    "subtitlePhone": "Escolha como o contactamos sobre as suas consultas.",
    "subtitleNamedPhone": "Escolha como a {clinic} o contacta sobre as suas consultas.",
    "invalidTitle": "Ligação inválida ou expirada",
    "invalidBody": "Esta ligação já não é válida. Abra a ligação de preferências do email mais recente que recebeu.",
    "suppressedNotice": "Este endereço está atualmente a bloquear todo o email de marketing. Ative uma opção acima para voltar a receber.",
    "reminders": {
      "title": "Lembretes de consulta",
      "help": "Como prefere que o avisemos das consultas que já tem marcadas.",
      "email": {
        "label": "Por email",
        "help": "Confirmações e lembretes enviados para o seu endereço de email."
      },
      "sms": {
        "label": "Por SMS",
        "help": "Uma mensagem curta para o telemóvel que temos no seu processo, na véspera."
      },
      "noneWarning": "Com as duas opções desligadas, não lhe enviaremos lembretes. A sua consulta mantém-se — terá apenas de a recordar sozinho, e pode sempre ligar-nos."
    },
    "frequencyTitle": "Com que frequência?",
    "frequency": {
      "all": "Tudo o que a clínica enviar",
      "occasional": "Apenas mensagens ocasionais (aniversário)",
      "none": "Nenhuma"
    },
    "purpose": {
      "marketing": {
        "label": "Novidades, dicas e campanhas",
        "help": "Conselhos de saúde oral, novidades da clínica e campanhas ocasionais."
      },
      "feedback": {
        "label": "Pedidos de opinião",
        "help": "Um breve questionário depois da consulta sobre como correu. Fica entre si e a clínica. Se recusar, deixamos de o enviar sempre que depende da sua autorização; a clínica pode ainda enviá-lo como parte da sua monitorização de qualidade."
      }
    },
    "stopAll": "Deixar de receber tudo",
    "stopAllHelp": "Continuará a receber mensagens sobre marcações que já tem (confirmações, lembretes e cancelamentos).",
    "provenance": "Última alteração a {when}, através de {source}.",
    "saved": "Preferências guardadas.",
    "saveFailed": "Não foi possível guardar. Tente novamente."
  },
  "pagination": {
    "label": "Paginação",
    "results": "{count, plural, =0 {0 resultados} one {# resultado} other {# resultados}}",
    "showing": "A mostrar <b>{from}–{to}</b> de <b>{total}</b>",
    "prev": "Anterior",
    "next": "Seguinte",
    "previousPage": "Página anterior",
    "nextPage": "Página seguinte"
  },
  "listFilter": {
    "search": "Pesquisar",
    "clinic": "Clínica",
    "allClinics": "Todas as clínicas",
    "period": "Período",
    "apply": "Filtrar",
    "reset": "Limpar filtros"
  },
  "dateRange": {
    "placeholder": "Qualquer data",
    "clear": "Limpar datas"
  },
  "login": {
    "showPassword": "Mostrar palavra-passe",
    "hidePassword": "Ocultar palavra-passe",
    "errors": {
      "invalidCredentials": "E-mail ou palavra-passe incorretos.",
      "emailNotConfirmed": "O e-mail desta conta ainda não foi confirmado.",
      "rateLimited": "Demasiadas tentativas. Aguarde um momento e tente novamente."
    },
    "forgotPassword": "Esqueceu-se da palavra-passe?"
  },
  "account": {
    "confirm": {
      "title": "Confirme que é você",
      "body": "Seleccione continuar para abrir a sua conta. Por segurança, esta hiperligação só funciona quando é você a seleccionar o botão.",
      "continue": "Continuar",
      "expiredTitle": "Esta hiperligação expirou",
      "expiredBody": "As hiperligações de conta são válidas por tempo limitado e só podem ser usadas uma vez. Peça outra para continuar.",
      "invalidTitle": "Esta hiperligação não é válida",
      "invalidBody": "Verifique se copiou a hiperligação completa do e-mail, ou peça outra.",
      "requestNew": "Pedir nova hiperligação"
    },
    "setPassword": {
      "title": "Escolha uma palavra-passe",
      "description": "É esta a palavra-passe que vai usar para entrar a partir de agora.",
      "newPassword": "Nova palavra-passe",
      "confirmPassword": "Confirmar palavra-passe",
      "submit": "Guardar palavra-passe",
      "mismatch": "As duas palavras-passe não coincidem.",
      "noSession": "Esta hiperligação já não está activa. Peça outra para escolher a sua palavra-passe."
    },
    "forgot": {
      "title": "Esqueceu-se da palavra-passe?",
      "description": "Introduza o seu e-mail e enviamos-lhe uma hiperligação para escolher uma nova.",
      "submit": "Enviar hiperligação",
      "backToLogin": "Voltar a entrar",
      "sentTitle": "Verifique o seu e-mail",
      "sentBody": "Se esse endereço pertencer a uma conta, enviámos uma hiperligação para escolher uma nova palavra-passe."
    }
  }
}
